function enable_arrows() {
  let arrows_left = document.querySelectorAll('.product-media-arrows-left');
  arrows_left.forEach(function(item) {
    item.addEventListener('click', function(e) {
      
      e.preventDefault(); 
      e.stopPropagation();
      let total_images = -1;
      //alert(this.getAttribute('data-left'));
      let left_spot = this.getAttribute('data-left');
      let left_spot_minus_one = left_spot - 2;
      let elem = this.closest('.product-grid-slide-container').querySelectorAll(".product-grid-slide");
      let new_active_image = elem[left_spot - 2];
      //alert(link2);
      //alert(elem);
      //alert(left_spot_minus_one);
      //alert(total_images);
      if(left_spot_minus_one > total_images) {
        removeActiveElem(elem);
        //elem[left_spot - 1].classList.remove('is-active');
        new_active_image.classList.add('is-active');
      }

      
    });
  });

  let arrows_right = document.querySelectorAll('.product-media-arrows-right');
  arrows_right.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.preventDefault(); 
      e.stopPropagation();
      let total_images = this.closest('.product-grid-slide-container').getAttribute('data-grid-images');
      //alert(this.getAttribute('data-right'));
      let right_spot = this.getAttribute('data-right');
      let right_spot_minus_one = right_spot - 1;
      let elem = this.closest('.product-grid-slide-container').querySelectorAll(".product-grid-slide");
      let new_active_image = elem[right_spot - 1];
      if(right_spot_minus_one < total_images) {
        //elem[right_spot - 2].classList.remove('is-active');
        removeActiveElem(elem);
        new_active_image.classList.add('is-active');
      }
    })
  })

  let images_hover = document.querySelectorAll('.js-product-grid-image-slider-hover-trigger');
  images_hover.forEach((item) => {
    item.addEventListener('mouseenter', function () {
      let elem = this.querySelectorAll(".product-grid-slide");
      removeActiveElem(elem);
      //elem[0].classList.remove('is-active');
      elem[1].classList.add('is-active');
      }
    );
  });
  images_hover.forEach((item) => {
    item.addEventListener('mouseleave', function () {
      let elem = this.querySelectorAll(".product-grid-slide");
      removeActiveElem(elem);
      //elem[1].classList.remove('is-active');
      elem[0].classList.add('is-active');
      }
    );
  });

  function removeActiveElem(elem){
    elem.forEach(function(item){
      item.classList.remove('is-active');
    })
  }
}
$(document).ready(function() {
  enable_arrows();
  console.log('arrows enabled')
});